export function timestampMs(value: string | number | Date | null | undefined): number {
  if (value == null || value === '') return 0;
  const t = new Date(value).getTime();
  return Number.isFinite(t) ? t : 0;
}

export function compareNewestFirst(
  a: string | number | Date | null | undefined,
  b: string | number | Date | null | undefined
): number {
  return timestampMs(b) - timestampMs(a);
}

export function sortNewestFirst<T>(
  items: T[],
  getDate: (item: T) => string | number | Date | null | undefined
): T[] {
  return [...items].sort((a, b) => compareNewestFirst(getDate(a), getDate(b)));
}
